function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgBodyweightMan(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M10.794 8.873l3.91 3.004c.279.215.67.187.918-.066a.728.728 0 000-1.014l-4.03-4.115a1.458 1.458 0 00-1.033-.44l-4.244-.029a1.458 1.458 0 00-1.05.44l-4.06 4.144a.728.728 0 000 1.014c.248.253.64.28.92.066L5.92 8.96l.258 2.072-.528 3.101-1.778 7.71a.895.895 0 00.563 1.021h0a.87.87 0 001.125-.569l2.75-7.686h.131l2.75 7.686a.87.87 0 001.124.569.894.894 0 00.563-1.02l-1.81-7.864-.57-3.035.295-2.072zM10.275 2.863c0 1.028-.817 1.862-1.824 1.862-1.008 0-1.825-.834-1.825-1.862C6.626 1.833 7.443 1 8.451 1c1.007 0 1.824.834 1.824 1.863z",
    stroke: props.fillSecondary
  }));
}

export default SvgBodyweightMan;